module.exports = __webpack_public_path__ + "static/media/CM-marca_tagline-positiva-RGB.c9f9a669.svg";